module.exports = __webpack_public_path__ + "img/tart.a51a9208.png";